import React from "react";
//import PropTypes from 'prop-types';

import { FormField } from "./Features";
import { useActions, useData } from "state/hooks";
import { change } from "state/actions/data";
import ComponentModeSelect from "playground/designer/ComponentEditor/ComponentModeSelect";
import Field from "containers/Field/Field";

function detectMode(data) {
    if (data?.ui_mode) return data?.ui_mode;

    const mapStr = data?.template_id || "";

    if (["@query"].includes(mapStr)) {
        return "query-result";
    }

    return "own-items";
}

function changeMode(mode, data) {
    let next = { ...data };
    switch (mode) {
        case "own-items":
            next.template_id = null;
            break;
        case "query-result":
            next.template_id = "@query";
            break;
        default:
            break;
    }
    return next;
}

const modes = {
    "own-items": "Własne elementy",
    "query-result": "Wynik zapytania",
};

export function FormSelect(props) {
    const { type, id, children } = props;
    const data = useData({ type, id });
    const mode = detectMode(data);
    const { onChangeEntity } = useActions({ onChangeEntity: change });
    const selectMode = (mode) => {
        onChangeEntity(type, id, changeMode(mode, data));
    };
    return (
        <>
            <ComponentModeSelect
                onChange={selectMode}
                value={mode}
                options={modes}
            />
            {children}
            <FormField />
            <Field
                id={"items"}
                label={"Items"}
                fieldType={"collection"}
                zmapAs={["items", "collection"]}
            />
        </>
    );
}

FormSelect.propTypes = {};

FormSelect.defaultProps = {};

export default FormSelect;
